// extracted by mini-css-extract-plugin
export default {"nav-item":"sidebar_nav-item__r-AGr","log-out-button":"sidebar_log-out-button__t5tiy"};